/*
 * @Author: 陈大仙人
 * @Date: 2022-05-31 20:12:00
 * @LastEditors: yuxh yuxh_157@163.com
 * @LastEditTime: 2024-06-18 15:13:44
 * @FilePath: /akx-datacloud-main/src/login/api/user/index.js
 */
import http from "../../../util/http.js";
export function checkLogin(options) {
  options.url = "/version/queryCurrentVersion";
  options.headers = {
    token: localStorage.getItem("USER_TOKEN") || "",
  };
  options.failTip = false;
  return http.get(options);
}
export function getCurrentVersion(options) {
  options.url = "/version/queryCurrentVersion";
  return http.post(options);
}
// export function login(options) {
//   options.url = "/common/tempLogin";
//   options.failTip = false;
//   return http.post(options);
// }
export function login(options) {
  options.url = "/data/user/userLogin";
  options.failTip = false;
  return http.post(options);
}
export function selectService(options) {
  options.url = "/data/user/selectService";
  return http.post(options);
}

export function logout(options) {
  options.url = "/common/tempLogout";
  return http.post(options);
}

export function getVersion(options) {
  options.url = "/version/queryCurrentVersion";
  return http.post(options);
}
export function getService(options) {
  options.url = "/bee/user/service/getBySId";
  return http.post(options);
}

// export function register(options) {
//     options.url = '/employee/register'
//     options.failTip = false
//     return http.post(options)
// }

export function register(options) {
  options.url = "/data/user/registerUser";
  options.failTip = false;
  return http.post(options);
}

export function getCode(options) {
  //   options.url = "/employee/sendSMS";
  options.url = "/data/user/sendSMS";
  return http.get(options);
}

export function getWxLoginState(options) {
  options.url = "/user/common/loginByWechatKey";
  return http.get(options);
}

// 白名单接口
export function whiteQuery(options) {
  options.url = "/common/whiteQuery";
  return http.get(options);
}
